<template>
  <div class="wrap-content wrap-content-anlysis wrap-bg f-tal">
    <div class="list-filter-wrap-box">
      <v-list-filter
        v-model="bindForms"
        :form-arr="formArr"
        :is-add-btn="false"
        form-item-position="row"
        class="list-filter bg-white"
        @changeFormBind="changeFormBind" />
    </div>
    <div class="wrap-main-content">
      <!--柱状图列表集合-->
      <section class="chart-list">
        <ul class="f-df f-fww">
          <li
            v-for="item in barList"
            :key="item.id"
            class="item-bar-chart-box bg-white mg-top15 pd15 bg-white f-pr">
            <v-title :title="item.name" :tip-txt="item.tipTxt" mg-btm="mg-btm10" class="f-pa chart-title-box" />
            <no-data v-if="item.isNodata && !item.isLoading" height="430" />
            <div
              v-show="!item.isNodata"
              :id="item.id"
              v-loading="item.isLoading"
              :class="item.id"
              element-loading-text="加载中"
              element-loading-spinne-r="el-icon-loading"
              class="chart-box"
            ></div>
          </li>
        </ul>
      </section>
      <!--内容列表-->
      <section class="pd15 bg-white mg-top15">
        <v-title :tip-txt="titleTxt[0].tipTxt" title="内容列表" mg-btm="f-jcsb" />
        <v-table-list ref="tableList" />
      </section>
    </div>
  </div>
</template>

<script>
import pageConfig from './page.config.js'
import noData from '@/components/nodata.vue'
import vListFilter from '@/components/form-filter/index.vue'
import vTitle from '@/components/vTitle.vue'
import vTableList from './content-table/index.vue'
import $filterCommon from '@/components/form-filter/index.js'
import mixin from '@/views/analysis/analysis.js'
import chartRender from '@/views/analysis/chartRender.js'
import {
  getContentAnalysis
} from '@/api/analysis/content.js'
export default {
  components: {
    noData,
    vListFilter,
    vTitle,
    vTableList
  },
  mixins: [mixin, chartRender],
  data() {
    return {
      isLoading: [false],
      titleTxt: pageConfig.titleTxt,
      bindForms: {},
      formArr: [],
      formRules: {},
      barList: []
    }
  },
  mounted() {
    // 柱状图列表集合初始化
    this.barList = JSON.parse(JSON.stringify(pageConfig.barList))
    // 页面初始化
    this.init()
  },
  methods: {
    init() {
      // 请求所有条件
      const filterAjaxList = JSON.parse(JSON.stringify(pageConfig.filterAjaxList))
      Promise.all(filterAjaxList.map(item => $filterCommon.getLabelCommon(item.method, item.url, item.param, item))).then(data => {
        const formArr = JSON.parse(JSON.stringify(pageConfig.filterForm))
        // 初始化所有筛选条件集合
        const filterObj = $filterCommon.filterChooseHandle(formArr, data)
        // 初始化当前选择的筛选条件
        this.bindForms = filterObj.filterChooseObj
        this.formArr = filterObj.filterList
        // 品牌默认值
        const brandItem = this.formArr.find(item => item.id === 'brand') || {}
        this.bindForms.brand = brandItem.children[0].id
        const indexItem = this.formArr.find(item => item.id === 'index') || {}
        this.bindForms.index = indexItem.children[0].id
        const $storeFilter = this.$store.state.platParam
        this.bindForms = Object.assign(this.bindForms, $storeFilter)
        // 默认时间初始化，如果$store存在默认时间选择，优先选择，否则默认初始化的时间
        const timeChooseItem = this.formArr.find(item => item.id === ($storeFilter.timeType ? 'timeType' : 'dateMonth')) || {}
        this.changeFormBind(this.bindForms, timeChooseItem, $storeFilter.timeType || this.bindForms[timeChooseItem.intValue])
        // // 页面统一请求初始化并且请求
        // const timeChooseItem = this.formArr.find(item => item.id === 'dateMonth') || {}
        // this.changeFormBind(this.bindForms, timeChooseItem, this.bindForms[timeChooseItem.intValue])
        // 请求完成之后开始请求内容列表
        setTimeout(() => {
          if (this.$refs.tableList) this.$refs.tableList.init()
        }, 600)
      })
    },
    pageTotalAjax() {
      // 图表更新
      this.barInt()
    },
    // 图表初始化
    barInt() {
      const promiseAll = this.barList.map((item, index) => {
        item.isLoading = true
        item.isNodata = false
        return getContentAnalysis(Object.assign(this.getParam(), {
          type: item.type
        }))
      })
      const seriesData = [
        {
          name: this.bindForms.brand,
          type: 'bar',
          data: [],
          itemColor: '#FFC750',
          emphasisColor: '#FFB600',
          key: 'scnt'
        }, {
          name: this.bindForms.target,
          type: 'bar',
          data: [],
          itemColor: '#326CFA',
          emphasisColor: '#326CFA',
          key: 'tcnt'
        }
      ]
      // 获取指标类型的中文
      const indexObj = this.formArr[6].children.find(item => item.id === this.bindForms.index) || {}
      Promise.all(promiseAll).then(data => {
        this.barList.forEach((item, index) => {
          item.isLoading = false
          const res = data[index].data || []
          item.isNodata = !res.length
          if (res.length) this.barRender(item.id, 'name', JSON.parse(JSON.stringify(seriesData)), res, indexObj.name)
        })
      })
    },
    // 是否爆款
    changePopular() {
      this.refreshList()
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.wrap-content{
  & .chart-box{
    height: 400px;
  }
  .chart-title-box{
    top: 15px;
    left: 15px;
    z-index: 2;
  }
  & .item-bar-chart-box{
    width: calc(~'(100% - 15px) / 2');
    &:nth-child(2n){
      margin-left: 15px;
    }
  }
}
.is-popular-type{
  margin-top: 2px;
  margin-right: 66px;
  color: #222;
}
.list-filter-wrap-box{
  position: relative;
}
.wrap-content-anlysis .wrap-main-content{
  margin-top: 0;
}
</style>
